import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ambassador-clicks-debug")({
  component: lazyRouteComponent(() => import("./-pages/admin.ambassador-clicks-debug")),
});
